import { css, styled } from "react-emotion";

import { flexColumn } from "appStyles";

export const container = css`
  ${flexColumn}
  position: relative;
  z-index: 2;
  width: 100%;
  height: 90%;
  max-height: 675px;
  overflow-y: scroll;
  padding: 15px;

  * {
    margin-bottom: 10px;
  }

  ::-webkit-scrollbar {
    height: 4px;
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.075);
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgb(192, 192, 192);
    border-radius: 10px;
    width: 8px;
    height: 4px;
    &:hover {
      background-color: rgb(124, 124, 124);
    }
  }
`;

export const content = css`
  margin-top: 2rem;
  z-index: 2;
`;
